import {InvalidateOptions, useMutation, useQueryClient} from '@tanstack/react-query';
import {useSearchDocsInfiniteQueryCache} from '../../sidebar/search-results/search-docs-infinite-query';
import {useFindUsagesQueryCache} from './use-find-usages-query';
import {useDocumentQueryCache} from './use-document-query';
import {useRecentsQueryCache} from './use-recents-query';
import {apiClient} from '../../../../../utils/api-client';

function useFavoritesQueryCache() {
    const queryClient = useQueryClient();

    function invalidate() {
        queryClient.invalidateQueries({queryKey: ['favoritesViewMode']}, {
            refetchType: 'inactive'
        } as InvalidateOptions);
    }

    return {invalidate};
}

export function useToggleFavoriteMutation() {
    const favoritesQueryCache = useFavoritesQueryCache();
    const searchQueryCache = useSearchDocsInfiniteQueryCache();
    const findUsagesQueryCache = useFindUsagesQueryCache();
    const documentQueryCache = useDocumentQueryCache();
    const recentDocsCache = useRecentsQueryCache();

    return useMutation<void, unknown, ViewModeDoc, unknown>({
        mutationFn: (document) =>
            (document.userFavorite
                ? apiClient.callApi<object>({
                      path: `documents-revisions-service/api/user/documents/${document.accession}/favorite`,
                      method: 'DELETE'
                  })
                : apiClient.post<object>({
                      path: `documents-revisions-service/api/user/documents/${document.accession}/favorite`
                  })
            ).then(() => {
                favoritesQueryCache.invalidate();
                searchQueryCache.setIsDocumentFavorite(document.id, !document.userFavorite);
                documentQueryCache.changeIsDocumentFavorite(
                    document.accession,
                    !document.userFavorite
                );
                findUsagesQueryCache.invalidate({});
                recentDocsCache.invalidate();
            })
    });
}
